module.exports = __webpack_public_path__ + "img/characterAnime12.8fc23559.png";